<div class="current-position-editor">
  <div class="row">
    <mat-form-field class="mat-form-field-readonly flex-grow">
      <input matInput [(ngModel)]="positionName"
        placeholder="{{'current position' | translate: ['tmc-yard.widgets.filter-administration.details-editor.transport.current-position-editor.current-position', translationService.language]}}"
        [readonly]="true">
    </mat-form-field>

    <button mat-flat-button type="button" (click)="assignNextProcessingPosition()" class="small-button assign-button"><i
        class="fa-light fa-sitemap"></i></button>
  </div>
</div>